// Global
import React from 'react';

// Local
import { Content } from '@generated/Content/Image.model';
import { Image } from './Image';
import ImageWrapper from 'components/helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import LinkWrapper from 'components/helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import CtaLink from 'components/helpers/Atoms/Cta/CtaLink';
import useDictionary from 'lib/hooks/useDictionary';

type ImageProps = Content.Image.ImageContent;

export const Default = (props: ImageProps) => {
  const { getDictionaryValue } = useDictionary();
  /*
   * Rendering
   */

  if (!props.fields) {
    return <></>;
  }
  return (
    <Image
      image={<ImageWrapper field={props.fields?.image} />}
      showOpenInNewTabCTA={props.fields?.showCTAonImage?.value}
      onImageCTA={
        <CtaLink
          url={props.fields?.image?.value?.src}
          text={
            getDictionaryValue('Components.Image.OnImageCTA') ||
            (props.fields?.image?.value?.alt as string)
          }
          target="_blank"
          ctaStyle="filled"
          ctaComponentClass="component-image-color-button-color-on-image"
        />
      }
      belowImageCTA={
        <LinkWrapper
          field={props.fields?.cta}
          ctaComponentClass="component-image-color-button-color-below-image"
          ctaStyle="link"
        />
      }
    />
  );
};
